import { h, Host, Component, Prop, Element } from '@stencil/core';
import state from '../../state';
import { getViewportValue } from '../../utils';

@Component({
  tag: 'om-minimize-button',
  styleUrl: './minimize-button.css',
  scoped: true,
})
export class MinimizeButton {
  @Element() el: HTMLElement;
  @Prop() handleMinimize: () => void;
  @Prop() overlayState?: any;
  @Prop() overlayStore?: any;

  componentWillRender() {
    // Ensure positioning is always set explicitly via inline styles
    this.el.style.position = 'absolute';
    this.el.style.top = '5px';
    this.el.style.right = '53px';
    this.el.style.zIndex = '103';
  }

  render() {
    const currentState = this.overlayState || state;
    // Handle both acquisition (content[currentScreen]) and notification (content directly)
    const contentForColor = currentState.currentScreen
      ? currentState.content[currentState.currentScreen]
      : currentState.content;

    return (
      <Host
        style={{
          '--minimize-button-color': getViewportValue(
            contentForColor?.closeIcon,
            'colour',
            currentState.isMobileViewport,
          ),
        }}
      >
        <om-clickable-element
          element={{ field: 'closeIcon' }}
          overlayState={this.overlayState}
          overlayStore={this.overlayStore}
        >
          <button
            tabindex="0"
            type="button"
            class="minimize-btn"
            onClick={() => {
              // Only allow minimize in test/live mode, not in preview mode
              if (currentState.mode !== 'preview') {
                this.handleMinimize();
              }
            }}
            aria-label="Minimize to mini overlay"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="black"
              viewBox="0 0 14 14"
              stroke-width="2"
              stroke="currentColor"
              width="20"
              height="20"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M0 7h14" />
            </svg>
          </button>
        </om-clickable-element>
      </Host>
    );
  }
}
